<template>
  <a-modal
    visible
    closable
    title="房屋审核"
    @cancel="handleCancel"
    @ok="handleOk"
    :confirmLoading="confirmLoading">
    <a-form-model hideRequiredMark ref="ruleForm" :model="data" :rules="rules">
      <a-form-model-item label="审核结果" class="m-b-24" prop="state">
        <a-radio-group v-model="data.state" @change="onChange">
          <a-radio value="pass">通过</a-radio>
          <a-radio value="notPass">不通过</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <!-- <a-form-model-item
        v-if="data.state === 'refused'"
        label="拒绝原因"
        class="m-b-24"
        prop="reason"
      >
        <a-textarea v-model="data.reason" placeholder="请输入拒绝原因" :rows="10" />
      </a-form-model-item> -->
    </a-form-model>
    </a-modal>
</template>

<script>
export default {
  props: {
    record: Object,
    vm: Object
  },
  data () {
    return {
      confirmLoading: false,
      data: {
        state: '' // 审核状态
        // reason: '' // 审核拒绝时的原因
      },
      rules: {
        state: [{ required: true, message: '审核结果不可为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onChange (e) {
      this.data.state = e.target.value
    },
    async handleOk () {
      try {
        this.confirmLoading = true
        console.log('dddata', this.data)
        if (!this.data.state) {
          this.confirmLoading = false
          return this.$notification['warning']({
            message: '请选择审核结果'
          })
        }
        await this.$tkParse.put(`/classes/examine/${this.record.objectId}`, {
          state: this.data.state,
          verifiedAt: new Date().toISOString()
        })
        this.confirmLoading = false
        this.$emit('complete')
        this.vm.refresh()
        this.$notification['success']({
          message: '操作成功'
        })
      } catch (e) {
        console.log('房屋审核异常', e)
        this.confirmLoading = false
        this.$notification['error']({
          message: '网络错误,请重试'
        })
      }
    },
    handleCancel () {
      this.$emit('complete', 'cancel')
    }
  }
}
</script>

<style>

</style>
